import { render, staticRenderFns } from "./addressCard.vue?vue&type=template&id=1a2db2f2&scoped=true&"
import script from "./addressCard.vue?vue&type=script&lang=js&"
export * from "./addressCard.vue?vue&type=script&lang=js&"
import style0 from "./addressCard.vue?vue&type=style&index=0&id=1a2db2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2db2f2",
  null
  
)

export default component.exports